import CenteredContent from 'components/CenteredContent/CenteredContent';

import useStyles from './styles';

const ListWithPaginationAndCTASkeleton = () => {
  const styles = useStyles();
  const gridItems = [...Array(20)].map((_, index) => (
    <i className="skeleton" key={`${index}_skeleton`} />
  ));
  return (
    <div className={styles.root} data-testid="list-with-pagination-and-cta-fallback">
      <CenteredContent>
        <div className={styles.skeletonBannerHolder}>
          <i className="skeleton" />
        </div>
        <div>
          <div>
            <i className="skeleton" />
            <i className="skeleton" />
          </div>
          <div>
            <div>
              <i className="skeleton" />
              <i className="skeleton" />
              <i className="skeleton" />
            </div>
          </div>
        </div>
        <div>{gridItems}</div>
        <div>
          <i className="skeleton" />
          <i className="skeleton" />
        </div>
      </CenteredContent>
    </div>
  );
};
export default ListWithPaginationAndCTASkeleton;
